import { render } from "./EmailBrandingDrawer.vue?vue&type=template&id=4721d7c0&scoped=true&ts=true"
import script from "./EmailBrandingDrawer.vue?vue&type=script&lang=ts"
export * from "./EmailBrandingDrawer.vue?vue&type=script&lang=ts"

import "./EmailBrandingDrawer.vue?vue&type=style&index=0&id=4721d7c0&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4721d7c0"]])

export default __exports__